var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { color, Flex, Text } from '@bfa/common-ui';
import { openWindowUrl } from '@bfa/nextjs-common/utils';
import React from 'react';
import styled from 'styled-components';
import useBusinessConfiguration from '../../../../hooks/useBusinessConfiguration';
import { SOCIAL_POSTS_SECTION_EVENTS as EVENTS } from '../../../../utils/analytics/events';
var TextStyled = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n"], ["\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n"])), color('refreshmentsAccent'));
var SocialMediaEnum;
(function (SocialMediaEnum) {
    SocialMediaEnum["tiktok"] = "Tiktok";
    SocialMediaEnum["instagram"] = "Instagram";
    SocialMediaEnum["facebook"] = "Facebook";
})(SocialMediaEnum || (SocialMediaEnum = {}));
var SocialMediaIcons = function (_a) {
    var content = _a.content;
    var trackEvent = useBusinessConfiguration().trackEvent;
    var handleClick = function (socialMediaName, url) {
        trackEvent(__assign(__assign({}, EVENTS.CLICK_ON_SOCIAL_MEDIA_ICON), { label: "Click On ".concat(socialMediaName) }));
        openWindowUrl({ url: url, target: '_blank' });
    };
    return (React.createElement(Flex, { justifyContent: "center", mt: ['2rem', '2.4rem'] }, Object.values(SocialMediaEnum).map(function (name) {
        var socialMediaUrl = (content && content["socialMedia".concat(name, "Url")]) || '';
        var socialMediaIcon = "icon-ipsy-".concat(name).toLowerCase();
        return (React.createElement(TextStyled, { key: name, as: "span", className: socialMediaIcon, display: "flex", backgroundColor: "transparent", width: "3.2rem", height: "3.2rem", mx: "1.5rem", fontSize: "3.2rem", onClick: function () { return handleClick(name, socialMediaUrl); } }));
    })));
};
export default SocialMediaIcons;
var templateObject_1;
